export default function toggleSearchFilters() {
  function init() {
    function closeFilter() {
      $('.intranet-search-grid__toggle-filters').removeClass('intranet-search-grid__toggle-filters--open').attr('aria-expanded', 'false').attr('aria-label',$('.intranet-search-grid__toggle-filters').data('label-closed'));
      $('.intranet-search-grid__body').removeClass('intranet-search-grid__body--filters');
      $('#filter-panel').attr('tabindex', '-1');
    }

    function openFilter() {
      $('.intranet-search-grid__toggle-filters').addClass('intranet-search-grid__toggle-filters--open').attr('aria-expanded', 'true').attr('aria-label',$('.intranet-search-grid__toggle-filters').data('label-open'));
      $('.intranet-search-grid__body').addClass('intranet-search-grid__body--filters');
      $('#filter-panel').removeAttr('tabindex');
    }

    // Stato iniziale
    if ($(window).width() < 768) {
      closeFilter();
    } else {
      openFilter();
    }

    // Resize
    $(window).on('resize', function() {
      if ($(window).width() < 768) {
        closeFilter();
      } else {
        openFilter();
      }
    });

    // Toggle da bottone
    $('.intranet-search-grid .intranet-search-grid__toggle-filters').on('click',function(e) {
      const isOpen = $(this).attr('aria-expanded') === 'true';
      if (isOpen) {
        closeFilter();
      } else {
        openFilter();
      }
    });
  }

  $(document).ready(function() {
    if ($('.intranet-search-grid').length > 0) {
      init();
    }
  });
}